import { type LBIcon } from '@/assets/icons/icons';

import Tile from './Tile';

interface CenteredTileProps {
  icon?: LBIcon;
  title: string;
  description: string;
  content: React.ReactElement;
  leadingContent?: React.ReactElement;
  titleClassName?: string;
  descriptionClassName?: string;
}

export default function CenteredTile({
  icon,
  title,
  description,
  content,
  leadingContent,
  titleClassName = '',
  descriptionClassName = '',
}: CenteredTileProps) {
  return (
    <div className="flex fixed inset-0 w-screen min-h-full items-center justify-center p-4">
      <div className="bg-surface rounded-lg shadow-sm border border-border max-w-lg w-full">
        <Tile
          icon={icon}
          title={title}
          description={description}
          leadingContent={leadingContent}
          titleClassName={titleClassName}
          descriptionClassName={descriptionClassName}
          content={content}
        />
      </div>
    </div>
  );
}
